import Vue from "vue/dist/vue.esm.js";
import {
	FormCheckboxPlugin,
	FormFilePlugin,
	FormGroupPlugin,
	FormInputPlugin,
	FormPlugin,
	FormRadioPlugin,
	FormSelectPlugin,
	FormTextareaPlugin,
	ImagePlugin,
	LayoutPlugin,
	ModalPlugin,
	PaginationPlugin,
	TooltipPlugin
} from 'bootstrap-vue';
import Nl2br from 'vue-nl2br'
import Toasted from 'vue-toasted';
import LayoutBackdrop from "./layout/Backdrop"
import LayoutHeader from "./layout/Header"
import LayoutFooter from "./layout/Footer"
import LayoutFeedback from "./layout/Feedback"
import LayoutGlobalComponents from "./layout/GlobalComponents"
import LayoutConsent from "./layout/Consent"
import Auth from "./auth/Auth"
import AuthSessionCheck from "./auth/SessionCheck"
import AuthPasswordReset from "./auth/password/Reset"
import AuthLoginUi from "./auth/login/Ui"
import Homepage from "./homepage/Homepage"
import ApplicationContainer from "./application/Container"
import ApplicationWelcome from "./application/Welcome"
import CustomerWelcome from "./customer/Welcome"
import CustomerRegistrationContainer from "./customer/registration/Container"
import CustomerConfirmationContainer from "./customer/confirmation/Container"
import CustomerAreaSecurity from "./customer-area/Security"
import CustomerAreaBilling from "./customer-area/Billing"
import CustomerAreaReconfirmMobilePhone from "./customer-area/ReconfirmMobilePhone"
import CustomerAreaReconfirmSearchPermission from "./customer-area/ReconfirmSearchPermission"
import CustomerAreaJob from "./customer-area/Job"
import CustomerAreaJobProfileAdd from "./customer-area/job-profile/Add"
import CustomerAreaJobProfileEdit from "./customer-area/job-profile/Edit"
import CustomerAreaSendoffs from "./customer-area/Sendoffs"
import CustomerAreaEmployments from "./customer-area/Employments"
import CustomerAreaExclusions from "./customer-area/Exclusions"
import ApplicationProfileJobs from "@/vue/application/profile/Jobs"
import ApplicationProfileJobEdit from "@/vue/application/profile/JobEdit"
import ApplicationProfileSkills from "@/vue/application/profile/Skills"
import ApplicationProfileCareer from "@/vue/application/profile/Career"
import ApplicationProfileSecurity from "@/vue/application/profile/Security"
import ApplicationProfileReconfirmMobilePhone from "@/vue/application/profile/ReconfirmMobilePhone"
import ApplicationProfileSendoffs from "@/vue/application/profile/Sendoffs"
import ApplicationProfileEmployments from "@/vue/application/profile/Employments"
import ApplicationProfileExclusions from "@/vue/application/profile/Exclusions"
import ApplicationJobFilter from "@/vue/application/job/filter/Container"
import CharacteristicTreeSelectItem from "./characteristic/tree-select/Item"
import LegitimationIdentificationUi from "@/vue/legitimation/identification/Ui"
import ApplicationJobVitaGridAreaSectionItem from "@/vue/application/job/vita/grid/SectionItem"
import PaymentPurchaseCallback from "@/vue/payment/PurchaseCallback"
import CharacteristicSelectedItemsItem from "@/vue/characteristic/selected-items/Item"
import InfoPage from "@/vue/info/Page"
import InfoSecrecy from "@/vue/info/Secrecy"
import InfoFaq from "@/vue/info/Faq"
import InfoFaqCustomer from "@/vue/info/FaqCustomer"
import InfoHowTo from "@/vue/info/HowTo"
import InfoPrices from "@/vue/info/Prices"
import store from "../store/index"
import "./filters"
import Inview from 'vueinview'
import VueSticky from 'vue-sticky'
import VueTrumbowyg from 'vue-trumbowyg';

import "../../../scss/styles.scss"
import {Settings} from "luxon";
import {error} from "@/helper/Log";

// third party
Vue.use(LayoutPlugin);
Vue.use(ModalPlugin);
Vue.use(FormPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormFilePlugin);
Vue.use(TooltipPlugin);
Vue.use(ImagePlugin);
Vue.use(PaginationPlugin);
Vue.use(Inview);
Vue.use(VueTrumbowyg);
Vue.directive('sticky', VueSticky);
Vue.component('nl2br', Nl2br);
Vue.use(Toasted);

// local
Vue.component('characteristic-tree-select-item', CharacteristicTreeSelectItem);
Vue.component('characteristic-selected-items-item', CharacteristicSelectedItemsItem);
Vue.component('application-job-vita-grid-area-section-item', ApplicationJobVitaGridAreaSectionItem);

store.commit('meta/setMeta', window._meta);

// setting global luxon locale
Settings.defaultLocale = "de";

Vue.config.errorHandler = (err) =>
{
	error(err);
}

window.onerror = (err) =>
{
	error(err);
}

// Register Service worker for Add to Home Screen option to work
if ('serviceWorker' in navigator)
{
	navigator.serviceWorker.register('/service-worker.js');
}

new Vue({
	el: '#container',
	store,
	components: {
		'layout-backdrop': LayoutBackdrop,
		'layout-header': LayoutHeader,
		'layout-footer': LayoutFooter,
		'layout-feedback': LayoutFeedback,
		'layout-global-components': LayoutGlobalComponents,
		'layout-consent': LayoutConsent,
		'info-secrecy': InfoSecrecy,
		'info-how-to': InfoHowTo,
		'info-faq': InfoFaq,
		'info-faq-customer': InfoFaqCustomer,
		'info-prices': InfoPrices,
		'info-page': InfoPage,
		'auth': Auth,
		'auth-session-check': AuthSessionCheck,
		'auth-password-reset': AuthPasswordReset,
		'auth-login-ui': AuthLoginUi,
		'homepage': Homepage,
		'application-welcome': ApplicationWelcome,
		'application-container': ApplicationContainer,
		'application-profile-jobs': ApplicationProfileJobs,
		'application-profile-job-edit': ApplicationProfileJobEdit,
		'application-profile-skills': ApplicationProfileSkills,
		'application-profile-career': ApplicationProfileCareer,
		'application-profile-security': ApplicationProfileSecurity,
		'application-profile-reconfirm-mobile-phone': ApplicationProfileReconfirmMobilePhone,
		'application-profile-sendoffs': ApplicationProfileSendoffs,
		'application-profile-employments': ApplicationProfileEmployments,
		'application-profile-exclusions': ApplicationProfileExclusions,
		'application-job-filter': ApplicationJobFilter,
		'customer-welcome': CustomerWelcome,
		'customer-registration-container': CustomerRegistrationContainer,
		'customer-confirmation-container': CustomerConfirmationContainer,
		'customer-area-security': CustomerAreaSecurity,
		'customer-area-billing': CustomerAreaBilling,
		'customer-area-reconfirm-mobile-phone': CustomerAreaReconfirmMobilePhone,
		'customer-area-reconfirm-search-permission': CustomerAreaReconfirmSearchPermission,
		'customer-area-job': CustomerAreaJob,
		'customer-area-job-profile-add': CustomerAreaJobProfileAdd,
		'customer-area-job-profile-edit': CustomerAreaJobProfileEdit,
		'customer-area-sendoffs': CustomerAreaSendoffs,
		'customer-area-employments': CustomerAreaEmployments,
		'customer-area-exclusions': CustomerAreaExclusions,
		'legitimation-identification-ui': LegitimationIdentificationUi,
		'payment-purchase-callback': PaymentPurchaseCallback,
	},
	mounted ()
	{
		const backgroundImage = document.getElementById("background-image");

		if (backgroundImage)
		{
			backgroundImage.style.display = 'block';
		}

		setInterval(() =>
		{
			const elements = document.getElementsByClassName('scrollbar-check');

			Array.from(elements).forEach(el =>
			{
				const parentNodeClassList = el.parentNode.classList;

				const isScrollable = el.scrollHeight > el.clientHeight;
				// add 5 percent threshold
				const hasScrolledToEnd = (el.scrollTop * 1.05) >= (el.scrollHeight - el.offsetHeight);

				parentNodeClassList.toggle("show-scrollbar-hint", isScrollable && !hasScrolledToEnd);
			});
		}, 1000)
	}
});
